import {
    INCREMENT_PAGE,
    SET_LOADING,
    SET_DONE,
    SET_TOTAL_PAGES,
    SET_LIST,
    SET_SEARCH_VALUE,
    SET_CATEGORIA_ID,
    SET_APPLIED_FILTERS,
    SET_PAGE,
} from './mutation-types'

export default {
    [INCREMENT_PAGE](state){
        state.filtersEdit.page++;
    },
    [SET_PAGE](state, payload){
        state.filtersEdit.page = payload;
    },
    [SET_LOADING](state, payload){
        state.loading = payload;
    },
    [SET_DONE](state, payload) {
        state.done = payload;
    },
    [SET_TOTAL_PAGES](state, payload){
        state.totalPages = payload;
    },
    [SET_LIST](state, payload){
        state.produtos = payload;
    },
    [SET_SEARCH_VALUE](state, payload){
        state.filtersEdit.search = payload;
    },
    [SET_CATEGORIA_ID](state, payload) {
        state.filtersEdit.categoriaId = payload;
    },
    [SET_APPLIED_FILTERS](state, payload) {
        state.appliedFilters = payload;
    }
}